(function() { window.GUID_015eb526_4009_409a_9699_5ecf474e0b48 = { getGuid: function() { return "015eb526-4009-409a-9699-5ecf474e0b48"; } }; })();
var CS;
(function (CS) {
    var App;
    (function (App) {
        var Views;
        (function (Views) {
            var _Shared;
            (function (_Shared) {
                var WallSections;
                (function (WallSections) {
                    class NewsfeedPublicity {
                        constructor() {
                            //NOTE: Si on change ce url, il faut changer xamarin car on regarde si le url contient DownloadFile pour gerer
                            //      comme il faut sur ios
                            this.downloadFileURL = "/Newsfeed/DownloadFile";
                            this.OnBindEvents();
                        }
                        OnDispose() {
                        }
                        OnBindEvents() {
                        }
                        downloadFile($target) {
                            let me = this;
                            let data = {
                                fileId: $target.data("file-id")
                            };
                            CS.Ajax.Get(me.downloadFileURL, data, (response) => {
                                if (response.error) {
                                    $target.addClass("unavailable");
                                    $target.text(`(${CS.Lang("file unavailable", "fichier indisponible")})`);
                                }
                                else {
                                    window.open(me.downloadFileURL + `?fileId=${data.fileId}`, "_self");
                                }
                            }, (extraParams) => { extraParams.showTopBuzyIndicator = false; });
                        }
                        setSeeMore($body, $element) {
                            let height = $body.find(".post-message").innerHeight(), $message = $body.find(".post-message");
                            const maxHeight = 350;
                            let contentIsHidden = false;
                            if (height > maxHeight + 100) {
                                //Ajout d'une section pour l'opacité graduelle dans le bas du post
                                $element.append(`<div class="opacity-gradient"></div>`);
                                let $opacityGradient = $element.find(".opacity-gradient");
                                // Affichage de la section pour le bouton "see more"
                                let $seeMoreDiv = $body.find("div.see-more");
                                $seeMoreDiv.css({
                                    "display": "block"
                                });
                                let $seeMoreButton = $seeMoreDiv.find("button.see-more");
                                //Limitation de la hauteur de la section du message
                                $element.css({
                                    "max-height": maxHeight
                                });
                                contentIsHidden = true;
                                $message.click(function () {
                                    if (contentIsHidden) {
                                        contentIsHidden = false;
                                        $element.css({
                                            "max-height": height * 2
                                        });
                                        $opacityGradient.hide();
                                        $seeMoreButton.off("click");
                                        $seeMoreButton.remove();
                                        return;
                                    }
                                });
                            }
                        }
                    }
                    WallSections.NewsfeedPublicity = NewsfeedPublicity;
                })(WallSections = _Shared.WallSections || (_Shared.WallSections = {}));
            })(_Shared = Views._Shared || (Views._Shared = {}));
        })(Views = App.Views || (App.Views = {}));
    })(App = CS.App || (CS.App = {}));
})(CS || (CS = {}));

//# sourceMappingURL=newsfeed-publicity.js.map
